// extracted by mini-css-extract-plugin
export default {"focusButton":"w3ZXCBfh1vPKF_3BRTgU","focused":"CSrgUVyDQ2cWJFKFYQhB"};